import Vue from 'vue';

import draggable from 'vuedraggable'

import TextInput from './FormElementTextInput'
import Email from './FormElementEmail'
import Phone from './FormElementPhone'
import LongTextInput from './FormElementLongTextInput'
import NumberInput from './FormElementNumberInput'
import SelectList from './FormElementSelectList'
import RadioButton from './FormElementRadioButton'
import Checkbox from './FormElementCheckbox'
import TimePicker from './FormElementTimePicker'
import DatePicker from './FormElementDatePicker'
import DatetimePicker from './FormElementDatetimePicker'
import Rating from './FormElementRating'
import Button from './FormElementButton'
import Carousel from './FormElementCarousel'
import Upload from './FormElementUpload'
import ElSwitch from './FormElementSwitch'
import TableComponent from './FormElementTable'
import HtmlComponent from './FormElementHtml'
import Elements from './Elements'
import Properties from './properties/Properties'
import UploadMediaFile from './uploadFileMedia'
import Instruction from './FormElementInstruction'
import SignaturePad from './SignaturePad'
import Divider from './Divider'
import Heading from './FormElementHeading'
import Paragraph from './FormElementParagraph'
import Name from './FormElementName'
import Address from './FormElementAddress'
import ImageUpload from './FormElementImageUpload'

// import vm from '@/main'
import app from '../../../../../mainApp'
import {
  FORM_IMAGE_POST
} from "../../../../Config/ApiUrl";

export const FormBuilder = new Vue({
  components: {
    Elements,
    Properties,
    draggable,
    TextInput,
    Email,
    Phone,
    LongTextInput,
    NumberInput,
    SelectList,
    RadioButton,
    Checkbox,
    TimePicker,
    DatePicker,
    DatetimePicker,
    Rating,
    Button,
    Carousel,
    Upload,
    ElSwitch,
    TableComponent,
    HtmlComponent,
    UploadMediaFile,
    Instruction,
    SignaturePad,
    Divider,
    Heading,
    Paragraph,
    Name,
    Address,
    ImageUpload,
  },
  data() {
    return {
      fields: [{
        fieldType: 'TextInput',
        label: 'Short Text',
        icon:'fa fa-text fa-2x',
        text: 'Short Text',
        group: 'form', //form group
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: true,
        isUnique: false,
        span: 12,
        labelWidth: 100,
        advancedOptions: true,
        showPassword: false,
        disabled: false,
        clearable: false,
        prepend: '',
        append: '',
        maxlength: 10,
        showWordLimit: false,
        showComments: false,
      },
      {
        fieldType: 'ImageUpload',
        showComments: false,
        text: 'Image Upload',
        imagetext: 'Your description goes here. Provide information, details, or any content you want to display in the left column.',
        imagepath: '/images/imagepreview.png',
        icon:'fa fa-image fa-2x',
        componentValue: '',
        componentId: 0,
        size: '14',
        alignment: 'left',
        formType:'',
      },
      {
        fieldType: 'Email',
        label: 'Email',
        icon:'fa fa-envelope fa-2x',
        text: 'Email',
        group: 'form', //form group
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: true,
        isUnique: false,
        span: 12,
        labelWidth: 100,
        advancedOptions: true,
        disabled: false,
        clearable: false,
        showComments: false,
      },
      {
        fieldType: 'Name',
        label: 'Full Name',
        text: 'Full Name',
        firstname: 'First Name',
        lastname: 'Last Name',
        icon:'fa fa-user fa-2x',
        group: 'form', //form group
        componentValue: '',
        firstNameValue: '',
        lastNameValue: '',
        disabled: false,
        showComments: false,
        // span: 24,
      },
      {
        fieldType: 'Address',
        label: 'Address',
        text: 'Address',
        streetAddress1Label: 'Street Address 1',
        streetAddress2Label: 'Street Address 2',
        cityLabel: 'City',
        stateLabel: 'State / Province',
        postalLabel: 'Postal / Zip Code',
        icon:'fa fa-map-marker fa-2x',
        group: 'form', //form group
        componentValue: '',
        streetAddress1Value: '',
        streetAddress2Value: '',
        cityValue: '',
        stateValue: '',
        postalValue: '',
        disabled: false,
        // span: 24,
        showComments: false,
      },
      {
        fieldType: 'Phone',
        label: 'Phone',
        icon:'fa fa-phone fa-2x',
        text: 'Phone',
        description: 'Phone',
        group: 'form', //form group
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: true,
        isUnique: false,
        span: 12,
        labelWidth: 100,
        advancedOptions: true,
        disabled: false,
        clearable: false,
        maxlength: 10,
        showWordLimit: false,
        showComments: false,
      },
      {
        fieldType: 'LongTextInput',
        label: 'Long Text',
        icon:'fa fa-text-height fa-2x',
        text: 'Long Text',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: true,
        isUnique: false,
        span: 24,
        labelWidth: 100,
        disabled: false,
        showComments: false,
      },
      {
        fieldType: 'NumberInput',
        label: 'Number',
        icon:'fa fa-outdent fa-2x',
        text: 'Number',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 12,
        labelWidth: 100,
        advancedOptions: true,
        disabled: false,
        stepStrictly: false,
        step: 1,
        hasMinValue: false,
        min: 1,
        hasMaxValue: false,
        max: 10,
        showComments: false,
      },
      {
        fieldType: 'SelectList',
        showComments: false,
        label: 'Select',
        icon:'fa fa-list fa-2x',
        text: 'Select',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 12,
        labelWidth: 100,
        isFromUrl: false,
        dataUrl: '',
        defaultValue: '',
        options: [{
          optionLabel: "Option Label 1",
          optionValue: "Option 1"
        },
        {
          optionLabel: "Option Label 2",
          optionValue: "Option 2"
        }
        ],
        advancedOptions: true,
        labelField: 'label',
        valueField: 'value',
        disabled: false,
        clearable: false,
        multiple: false,
        filterable: false,
        remote: false
      },
      {
        fieldType: 'Instruction',
        showComments: false,
        label: 'Instruction',
        icon:'fa fa-book fa-2x',
        text: 'Instruction',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100,
        isFromUrl: false,
        dataUrl: '',
        options: [{
          optionLabel: "Option Label 1",
          optionValue: "Option 1"
        },
        {
          optionLabel: "Option Label 2",
          optionValue: "Option 2"
        }
        ],
        advancedOptions: true,
        labelField: 'label',
        valueField: 'value',
        disabled: false,
        clearable: false,
        multiple: false,
        filterable: false,
        remote: false
      },
      {
        fieldType: 'RadioButton',
        showComments: false,
        label: 'Radio',
        text: 'Radio',
        icon:'fa fa-check-circle fa-2x',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100,
        isFromUrl: false,
        options: [{
          optionLabel: "Option Label 1",
          optionValue: "Option 1"
        },
        {
          optionLabel: "Option Label 2",
          optionValue: "Option 2"
        }
        ],
        advancedOptions: true,
        dataUrl: '',
        labelField: 'label',
        valueField: 'value'
      },
      {
        fieldType: 'Checkbox',
        showComments: false,
        label: 'Checkbox',
        text: 'Checkbox',
        icon:'fa fa-check fa-2x',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100,
        isFromUrl: false,
        options: [{
          optionLabel: "Option Label 1",
          optionValue: "Option 1"
        },
        {
          optionLabel: "Option Label 2",
          optionValue: "Option 2"
        }
        ],
        advancedOptions: true,
        dataUrl: '',
        labelField: 'label',
        valueField: 'value'
      },
      {
        fieldType: 'TimePicker',
        showComments: false,
        label: 'Time',
        icon:'fa fa-clock fa-2x',
        text: 'Time',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100
      },
      {
        fieldType: 'DatePicker',
        showComments: false,
        label: 'Date',
        text: 'Date',
        icon:'fa fa-calendar fa-2x',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100
      },
      {
        fieldType: 'DatetimePicker',
        showComments: false,
        label: 'Date time',
        icon:'fa fa-calendar-times fa-2x',
        text: 'Date-Time',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100
      },
      {
        fieldType: 'Rating',
        showComments: false,
        label: 'Rating',
        icon:'fa fa-star fa-2x',
        text: 'Rating',
        description: 'Text',
        group: 'form',
        componentValue: '',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: false,
        span: 24,
        labelWidth: 100,
        advancedOptions: true,
        rateValue: 0,
        showText: true,
        disabled: false,
        showScore: false,
        scoreUnit: 'points',
        colors: ['#AAAAAA', '#F7BA2A', '#FF9900'],
        texts: ['oops', 'disappointed', 'normal', 'good', 'great']
      },
      {
        fieldType: 'ElSwitch',
        showComments: false,
        label: 'Switch',
        text: 'Switch',
        icon:'fa fa-toggle-on fa-2x',
        description: 'Text',
        group: 'form',
        isUnique: false,
        span: 24,
        labelWidth: 100,
        activeText: '',
        inActiveText: ''
      },
      // {
      //   fieldType: 'Carousel',
      //   text: 'Carousel',
      //   group: 'static',
      //   isUnique: false,
      //   span: 24,
      //   labelWidth: 100,
      //   controlHeight: 150,
      //   itemsNumber: 4,
      //   items: [{
      //     url: ''
      //   }]
      // },
      // {
      //   fieldType: 'Upload',
      //   text: 'UploadFiles',
      //   group: 'form',
      //   componentValue: [],
      //   isUnique: false,
      //   span: 24,
      //   uploadURL: `http://127.0.0.2:8050/${FORM_IMAGE_POST}`
      //   // uploadURL: 'https://jsonplaceholder.typicode.com/posts/'
      // },
      {
        fieldType: 'UploadMediaFile',
        showComments: false,
        text: 'UploadMediaFile',
        description: 'Text',
        icon:'fa fa-file fa-2x',
        // group: 'form',
        componentValue: [],
        componentId: 0,
        // isUnique: false,
        // span: 24,
        // uploadURL: '',
        // uploadURL: 'https://jsonplaceholder.typicode.com/posts/'
        instruction: '',
        formType:'',
      },
      {
        fieldType: 'SignaturePad',
        showComments: false,
        text: 'SignaturePad',
        description: 'Text',
        icon:'fa fa-signature fa-2x',
        // group: 'form',
        componentValue: [],
        componentId: 0,
        disabled: false,
        // isUnique: false,
        // span: 24,
        // uploadURL: '',
        // uploadURL: 'https://jsonplaceholder.typicode.com/posts/'
        instruction: '',
        formType:'',
      },
      {
        fieldType: 'Divider',
        showComments: false,
        text: 'Divider',
        icon:'fa fa-minus fa-2x',
        // group: 'form',
        componentValue: [],
        componentId: 0,
        maxwidth: '100',
        maxheight: '2',
        color: '#000',
        dividerType: 'solid',
        formType:'',
      },
      {
        fieldType: 'Heading',
        showComments: false,
        text: 'Heading',
        heading: 'Heading',
        subheading: 'Subheading',
        icon:'fa fa-heading fa-2x',

        // group: 'form',
        componentValue: [],
        componentId: 0,
        size: '20',
        alignment: 'left',
        formType:'',
      },
      {
        fieldType: 'Paragraph',
        showComments: false,
        text: 'Paragraph',
        paragraph: 'Paragraph',
        icon:'fa fa-paragraph fa-2x',

        // group: 'form',
        componentValue: [],
        componentId: 0,
        size: '14',
        alignment: 'left',
        formType:'',
      },
      {
        fieldType: 'TableComponent',
        showComments: false,
        text: 'Table',
        description: 'Text',
        icon:'fa fa-table fa-2x',
        componentValue: [],
        group: 'form',
        isUnique: false,
        span: 24,
        tableColumns: [{
          prop: 'date',
          label: 'Date',
          width: 180
        }, {
          prop: 'name',
          label: 'Name',
          width: 180
        }, {
          prop: 'address',
          label: 'Address'
        }],
        tableDatas: []
      },
      {
        fieldType: 'Button',
        showComments: false,
        text: 'Button',
        description: 'Text',
        group: 'button',
        buttonText: 'Submit your form',
        isRequired: false,
        isHelpBlockVisible: false,
        isPlaceholderVisible: false,
        isUnique: true,
        span: 24,
        labelWidth: 100
      },
      
      // {
      //   fieldType: 'HtmlComponent',
      //   text: 'Html',
      //   group: 'static',
      //   isUnique: false,
      //   span: 24,
      //   htmlContent: '<h3>Hello World</h3>',
      //   advancedOptions: ''
      // }
      ],

      sortElementOptions: {
        group: {
          name: 'formbuilder',
          pull: false,
          put: true
        },
        sort: true
      },

      dropElementOptions: {
        group: {
          name: 'formbuilder',
          pull: 'clone',
          put: false
        },
        sort: false,
        filter: ".is-disabled"
      }
    }
  },
  methods: {
    deleteElement(index, form) {
      app.$store.state.formBuilder.activeField = [];
      app.$store.state.formBuilder.activeTabForFields = "elements";
      this.$delete(form, index);
    },

    cloneElement(index, field, form) {
      var cloned = _.cloneDeep(field) // clone deep lodash
      form.splice(index, 0, cloned)
    },

    editElementProperties(field) {
      // app.$store.state.formBuilder.activeField = field;
      // app.$store.state.formBuilder.activeTabForFields = "properties";
      app.$store.dispatch('setActiveField', field);
      app.$store.dispatch('setActiveTab', "properties");
    }
  }
});
